import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { message } from "antd";
import { useAuth } from '../../../contexts/AuthContext';
import { defaultHomePath } from '../../../lib/homePath';
import { Eye, EyeOff, User, Lock } from "feather-icons-react/build/IconComponents";
import AuthLayout from "./AuthLayout";
import styles from "./Login.module.css";

const Login = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [password, setPassword] = useState('');
  const [identifier, setIdentifier] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login, isAuthenticated, isLoading, user } = useAuth();

  // Redirect if already logged in
  if (!isLoading && isAuthenticated) {
    return <Navigate to={defaultHomePath(user)} replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const logged = await login(identifier, password);
      navigate(defaultHomePath(logged), { replace: true });
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Credenciales inválidas. Verifique su usuario o correo y contraseña.';
      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout loading={loading}>
      <div className={styles.formHeader}>
        <h2>Iniciar sesión</h2>
        <p>Ingrese sus credenciales para continuar</p>
      </div>

      <form onSubmit={handleSubmit} aria-busy={loading}>
        <div className={styles.field}>
          <label htmlFor="ec-username" className={styles.fieldLabel}>Usuario</label>
          <div className={styles.fieldWrap}>
            <span className={styles.fieldIcon} aria-hidden="true">
              <User size={18} />
            </span>
            <input
              id="ec-username"
              type="text"
              className={styles.input}
              placeholder="lgarcia"
              value={identifier}
              onChange={e => setIdentifier(e.target.value)}
              disabled={loading}
              autoComplete="username"
              required
            />
          </div>
          <small className={styles.fieldHint}>
            También puede iniciar sesión con su correo electrónico
          </small>
        </div>

        <div className={styles.field}>
          <div className={styles.fieldRow}>
            <label htmlFor="ec-password" className={styles.fieldLabel}>Contraseña</label>
            <Link to="/forgotpassword" className={styles.forgotLink} tabIndex={-1}>¿Olvidó su contraseña?</Link>
          </div>
          <div className={styles.fieldWrap}>
            <span className={styles.fieldIcon} aria-hidden="true">
              <Lock size={18} />
            </span>
            <input
              id="ec-password"
              type={passwordVisible ? 'text' : 'password'}
              className={`${styles.input} ${styles.inputPassword}`}
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              disabled={loading}
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              className={styles.eye}
              onClick={() => setPasswordVisible(v => !v)}
              tabIndex={-1}
              aria-label={passwordVisible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
            >
              {passwordVisible ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
        </div>

        <button
          type="submit"
          className={styles.submit}
          data-testid="login-submit"
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
              Iniciando sesión...
            </>
          ) : (
            'Iniciar sesión'
          )}
        </button>
      </form>
    </AuthLayout>
  );
};

export default Login;
